import axios from 'axios'
import { getToken } from '@/utils/auth'
import { removeToken } from '@/utils/auth'
import toast from '@/components/toast'
import router from '@/router'

const API_BASE_URL_MAP = {
  local: 'http://192.168.1.180:31001/api',
  // local: 'http://www.dangjian.com/admin-api/api',
  test: 'http://www.dangjian.com/admin-api/api',
  prod: 'https://aidj.gee.cn/admin-api/api',
}

const API_ENV = process.env.VUE_APP_API_ENV || 'local'

const baseURL = API_BASE_URL_MAP[API_ENV] || API_BASE_URL_MAP.local

const request = axios.create({
  baseURL,
  timeout: 15000,
})

request.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`
      config.headers.token = token
    }
    return config
  },
  (error) => Promise.reject(error),
)

function getHttpErrorMessage(status) {
  const messageMap = {
    400: '请求参数错误',
    401: '登录状态已失效，请重新登录',
    403: '无权限访问该资源',
    404: '请求资源不存在',
    500: '服务器异常，请稍后重试',
    502: '网关错误，请稍后重试',
    503: '服务不可用，请稍后重试',
    504: '请求超时，请稍后重试',
  }
  return messageMap[status] || '网络异常，请检查网络连接'
}

function redirectToLogin() {
  removeToken()
  if (router.currentRoute.value.path !== '/login') {
    router.push('/login')
  }
}

function isLoginExpiredResponse(data) {
  if (!data || typeof data !== 'object') {
    return false
  }

  return (
    data.error_code === 30004 ||
    data.code === 401 ||
    data.stat === 0 && data.error_code === 30004
  )
}

request.interceptors.response.use(
  (response) => {
    const { data } = response

    if (isLoginExpiredResponse(data)) {
      const message = data.error_msg || data.msg || '登录状态已失效，请重新登录'
      toast(message)
      redirectToLogin()
      return Promise.reject(new Error(message))
    }

    if (typeof data?.code === 'number' && data.code !== 200) {
      const message = data.msg || data.message || '请求失败'
      toast(message)
      return Promise.reject(new Error(message))
    }

    if (typeof data?.stat === 'number' && data.stat !== 1) {
      const message = data.msg || data.message || '请求失败'
      toast(message)
      return Promise.reject(new Error(message))
    }

    return data
  },
  (error) => {
    if (error.response?.status === 401) {
      toast('登录状态已失效，请重新登录')
      redirectToLogin()
      return Promise.reject(error)
    }

    const message = error.response
      ? getHttpErrorMessage(error.response.status)
      : error.message || '请求失败，请稍后重试'

    toast(message)
    return Promise.reject(error)
  },
)

export { API_BASE_URL_MAP, API_ENV, baseURL }
export default request
